import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Container, Content, FileName, FileSize, IconContainer, MetaInfo } from './Attachment.styled';
export const Loading = ({ stack }) => {
    return (React.createElement(Container, { "data-testid": "attachment-loading-skeleton", stack: stack },
        React.createElement(Content, { stack: stack },
            React.createElement(IconContainer, { stack: stack },
                React.createElement(Skeleton, { style: { width: 48, height: 48 } })),
            React.createElement(MetaInfo, { stack: stack },
                React.createElement(FileName, null,
                    React.createElement(Skeleton, { style: { width: 152 } })),
                React.createElement(FileSize, null,
                    React.createElement(Skeleton, { style: { width: 24 } }))))));
};
//# sourceMappingURL=Loading.js.map